import {
  ACCENT_PRESET_COLORS,
  DENSITY_PRESET_TOKENS,
  type AccentPreset,
  type DensityPreset,
} from '@s-blog/shared-types';

/**
 * 站长外观 token 注入 documentElement, 覆盖 global.css 的 :root 默认。
 * - 强调色套餐 (coral/rose/amber/magenta): 写 --aurora-accent 系列, 全站链接/chip/高亮/选区联动。
 * - 密度套餐 (compact/cozy/airy): 写 --glass-radius/--glass-blur, 全站玻璃卡圆角/模糊换气质。
 * 都是受限套餐 (非自由值) → 守 Aurora 品牌 (暖色弧 + 玻璃质感)。
 */
export function useThemeTokens() {
  function applyAccentPreset(preset: AccentPreset | null | undefined) {
    // coral / cozy 是 :root 默认值, 未设或选默认时不注入 (默认站点零侵入)
    if (!preset || preset === 'coral' || !ACCENT_PRESET_COLORS[preset]) return;
    const c = ACCENT_PRESET_COLORS[preset];
    const root = document.documentElement.style;
    root.setProperty('--aurora-accent', c.accent);
    root.setProperty('--aurora-accent-soft', c.accentSoft);
    root.setProperty('--aurora-magenta', c.magenta);
  }
  function applyDensity(preset: DensityPreset | null | undefined) {
    if (!preset || preset === 'cozy' || !DENSITY_PRESET_TOKENS[preset]) return;
    const t = DENSITY_PRESET_TOKENS[preset];
    const root = document.documentElement.style;
    root.setProperty('--glass-radius', `${t.glassRadius}px`);
    root.setProperty('--glass-blur', `${t.glassBlur}px`);
  }
  return { applyAccentPreset, applyDensity };
}
